// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconLogout = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
            <path
                fill="currentColor"
                d="M3.75,9.42857143 L2.25,9.42857143 C1.83585942,9.42857143 1.5,9.07671908 1.5,8.64285714 L1.5,2.35714286 C1.5,1.92328167 1.83585942,1.57142857 2.25,1.57142857 L3.75,1.57142857 C4.16414058,1.57142857 4.5,1.21957547 4.5,0.785714286 C4.5,0.351853098 4.16484368,0 3.75,0 L2.25,0 C1.00734365,0 0,1.05531277 0,2.35714286 L0,8.64285714 C0,9.94468723 1.00734365,11 2.25,11 L3.75,11 C4.16414058,11 4.5,10.6481477 4.5,10.2142857 C4.5,9.78042378 4.16484368,9.42857143 3.75,9.42857143 Z M11.7796876,4.94508914 L8.77968764,1.80223199 C8.48648429,1.49506657 8.01187491,1.49555813 7.71914077,1.80223199 C7.42617202,2.10915164 7.42617202,2.60636146 7.71914077,2.9132811 L9.44062471,4.71428571 L4.5,4.71428571 C4.08515632,4.71428571 3.75,5.06540186 3.75,5.5 C3.75,5.93459851 4.08539057,6.28571429 4.5,6.28571429 L9.44062471,6.28571429 L7.72078085,8.08745548 C7.4278121,8.39437512 7.4278121,8.89158494 7.72078085,9.19850458 C8.0137496,9.50542423 8.48835897,9.50542423 8.78132772,9.19850458 L11.7813277,6.05564744 C12.0726557,5.74799122 12.0726557,5.25200878 11.7796876,4.94508914 Z"
            />
        </svg>
    );
};

export default IconLogout;
